module.exports = __webpack_public_path__ + "img/exclamation.beaf830e.svg";